import { useMutation } from '@apollo/client';
import { useCallback } from 'react';
import { useIntl } from 'react-intl';

import type { EntityPagesArticleModuleUnfeatureArticleMutationVariables } from '../graphql/mutations/entity-pages-article-module-unfeature-article.gql-types';
import { EntityPagesArticleModuleUnfeatureArticleDocument } from '../graphql/mutations/entity-pages-article-module-unfeature-article.gql-types';

import { useArticlesModuleContext } from './use-articles-module-context/use-articles-module-context';

export const useUnfeatureArticleMutation = (): [
  (
    variables: EntityPagesArticleModuleUnfeatureArticleMutationVariables
  ) => Promise<void>,
  { loading: boolean },
] => {
  const { refetch } = useArticlesModuleContext();
  const { $t } = useIntl();

  const [handle, { loading }] = useMutation(
    EntityPagesArticleModuleUnfeatureArticleDocument
  );

  return [
    useCallback(
      async (
        variables: EntityPagesArticleModuleUnfeatureArticleMutationVariables
      ) => {
        try {
          const { data, errors } = await handle({
            variables,
          });

          const error = data?.contentUnfeatureArticle?.error || errors?.[0];
          if (error) {
            throw Error($t({ id: 'EP_GENERAL_FEEDBACK_ERROR' }), {
              cause: error,
            });
          }

          refetch();

          return;
        } catch (error) {
          throw Error($t({ id: 'EP_GENERAL_FEEDBACK_ERROR' }), {
            cause: error,
          });
        }
      },
      [handle, $t]
    ),
    { loading },
  ];
};
